import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCheckinGuests, setGuestCheckedIn } from '../api/plannerApi';
import PlannerPage from './PlannerPage';
import type { Guest } from '../types/board';

// Check-in only view. Renders the same planner layout locked to the Guest List tab,
// with the table read-only except the checked-in toggle. Never hits /planner-boards/edit/ —
// keeps door staff isolated from budget data at the API and bundle level.
export default function CheckInPage() {
  const { token = '' } = useParams();
  const [guests, setGuests] = useState<Guest[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getCheckinGuests(token)
      .then((r) => setGuests(r.guests))
      .catch(() => setError('Could not load guest list.'));
  }, [token]);

  const toggle = async (guestId: string, checkedIn: boolean) => {
    setGuests((gs) => gs && gs.map((g) => (g.id === guestId ? { ...g, checkedIn } : g)));
    try {
      const r = await setGuestCheckedIn(token, guestId, checkedIn);
      setGuests(r.guests);
    } catch {
      setGuests((gs) => gs && gs.map((g) => (g.id === guestId ? { ...g, checkedIn: !checkedIn } : g)));
    }
  };

  if (error) return <div className="p-8 text-center text-red-700">{error}</div>;
  if (!guests) return <div className="p-8 text-center opacity-60">Loading…</div>;

  return <PlannerPage checkin guests={guests} onToggleCheckedIn={toggle} />;
}
